import { useEffect, useState } from "react";
import { Skeleton } from "primereact/skeleton";
import "./SingleProductsToys.css";

export default function SingleProductsToys() {
  const productId = sessionStorage.getItem("productId");

  const [product, setProduct] = useState([]);
  const [productImg, setProductImg] = useState([]);
  const [mainImage, setMainImage] = useState("");

  useEffect(() => {
    if (productId) {
      fetchProductDetails();
      fetchProductImages();
    }
  }, [productId]);

  async function fetchProductDetails() {
    try {
      const res = await fetch(`/allToysByPID/${productId}`);
      const data = await res.json();
      if (!Array.isArray(data)) throw new Error("Data not in array format");
      setProduct(data);
    } catch (err) {
      console.error("Product fetch error:", err.message);
    }
  }

  async function fetchProductImages() {
    try {
      const res = await fetch(`/allProductsMediaByPID/${productId}`);
      const data = await res.json();
      if (!Array.isArray(data)) throw new Error("Media not in array format");
      setProductImg(data);
      if (data.length > 0) {
        setMainImage(`data:image/png;base64,${data[0].productImages}`);
      }
    } catch (err) {
      console.error("Image fetch error:", err.message);
    }
  }

  const handleThumbnailClick = (img) => {
    setMainImage(`data:image/png;base64,${img.productImages}`);
  };

  const renderSpec = (label, value) => {
    if (!value) return null;
    return (
      <div className="spec-row">
        <strong className="spec-label">{label}:</strong>
        <span>{value}</span>
      </div>
    );
  };

  return (
    <>
      <div className="toy-product-container">
        <div className="thumbnail-column">
          {productImg.map((img, idx) => (
            <img
              key={idx}
              src={
                img.productImages ? (
                  `data:image/png;base64,${img.productImages}`
                ) : (
                  <Skeleton />
                )
              }
              alt="Thumbnail"
              onClick={() => handleThumbnailClick(img)}
              className={`thumbnail-img ${
                mainImage.includes(img.productImages) ? "active-thumbnail" : ""
              }`}
            />
          ))}
        </div>

        <div className="main-image-column">
          <img
            src={mainImage || <Skeleton />}
            alt="Main Product"
            className="main-product-img"
          />
        </div>

        <div className="product-info-column">
          {product.map((prdct) => (
            <div key={prdct.productID}>
              <h2 className="product-title">{prdct.productName}</h2>
              <p>
                <strong>Price:</strong>{" "}
                <span className="product-price">₹{prdct.price}</span>
              </p>
              <p>
                <strong>Age Group:</strong> {prdct.ageGroup}
              </p>
              <p>
                <strong>Brand:</strong> {prdct.brand}
              </p>
              <a
                href={`https://wa.me/919490384177?text=Hi, I'm interested in buying the product: ${encodeURIComponent(
                  prdct.productName
                )}, Price: ₹${prdct.price}`}
                target="_blank"
                rel="noopener noreferrer"
                className="whatsapp-button"
              >
                Shop on WhatsApp
              </a>
            </div>
          ))}
        </div>
      </div>

      {product.map((prdct) => (
        <div key={`desc-spec-${prdct.productID}`} className="spec-container">
          <div>
            <h4>Description</h4>
            <p>{prdct.description}</p>
          </div>

          <div className="spec-section">
            <h4>Specifications</h4>

            <h5 className="section-heading">General</h5>
            <div className="spec-grid">
              {renderSpec("Type", prdct.type)}
              {renderSpec("Model Number", prdct.modelNumber)}
              {renderSpec("Color", prdct.color)}
              {renderSpec("Speed", prdct.speed)}
              {renderSpec("Weight", prdct.weight)}
              {renderSpec("Country of Origin", prdct.countryOfOrigin)}
              {renderSpec("Manufacturer", prdct.manufacturer)}
            </div>

            <h5 className="section-heading">Power Features</h5>
            <div className="spec-grid">
              {renderSpec("Battery Type", prdct.batteryType)}
              {renderSpec(
                "Battery Included",
                prdct.batteryIncluded ? "Yes" : "No"
              )}
              {renderSpec("Rechargeable", prdct.rechargeable ? "Yes" : "No")}
            </div>

            <h5 className="section-heading">Convenience Features</h5>
            <div className="spec-grid">
              {renderSpec(
                "Parental Remote",
                prdct.parentalRemote ? "Yes" : "No"
              )}
              {renderSpec(
                "MP3 Player Supported",
                prdct.mpThreePlayerSupported ? "Yes" : "No"
              )}
              {renderSpec(
                "Other Convenience Features",
                prdct.otherConvenienceFeatures
              )}
            </div>

            <h5 className="section-heading">Dimensions</h5>
            <div className="spec-grid">
              {renderSpec("Dimensions", prdct.dimentions)}
              {renderSpec("Maximum User Weight", prdct.maximumUserWeight)}
            </div>

            <h5 className="section-heading">Warranty</h5>
            <div className="spec-grid">
              {renderSpec("Warranty", prdct.warrenty)}
              {renderSpec("Covered in Warranty", prdct.coveredInWarranty)}
              {renderSpec(
                "Not Covered in Warranty",
                prdct.notCoveredInWarranty
              )}
            </div>
          </div>
        </div>
      ))}
    </>
  );
}
